exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".half[data-v-32f03530] {\n  width: 48%;\n  display: inline-block;\n}\n.mlauto[data-v-32f03530] {\n  margin-left: auto;\n}\n.detail-tags[data-v-32f03530] {\n  height: inherit !important;\n}\n.sns-icon-small[data-v-32f03530] {\n  width: 18px;\n  height: 18px;\n  -o-object-fit: contain;\n     object-fit: contain;\n}", ""]);

// exports
